/* SEQ Air Care individual Recent Job page */
'use strict';

(() => {
  function initPage(page) {
    if (!(page instanceof HTMLElement) || page.dataset.seqJobPageReady === 'true') return;
    page.dataset.seqJobPageReady = 'true';

    const slider = page.querySelector('[data-seq-job-page-slider]');
    const range = slider?.querySelector('[data-seq-job-page-range]');
    const before = slider?.querySelector('[data-seq-job-page-before]');
    const line = slider?.querySelector('[data-seq-job-page-line]');

    if (slider instanceof HTMLElement && range instanceof HTMLInputElement && before instanceof HTMLElement && line instanceof HTMLElement) {
      const setWidth = () => {
        const width = slider.getBoundingClientRect().width;
        if (width > 0) slider.style.setProperty('--job-slider-width', `${width}px`);
      };

      const update = value => {
        const position = Math.max(0, Math.min(100, Number(value) || 0));
        before.style.width = `${position}%`;
        line.style.left = `${position}%`;
        range.setAttribute('aria-valuenow', String(position));
      };

      range.addEventListener('input', event => update(event.currentTarget.value));
      const observer = typeof ResizeObserver === 'function' ? new ResizeObserver(setWidth) : null;
      observer?.observe(slider);
      if (!observer) window.addEventListener('resize', setWidth, { passive: true });
      setWidth();
      update(range.value);
    }

    const lightbox = page.querySelector('[data-seq-job-page-lightbox]');
    const lightboxImage = lightbox?.querySelector('[data-seq-job-page-lightbox-image]');
    const closeButton = lightbox?.querySelector('[data-seq-job-page-lightbox-close]');
    let lastTrigger = null;

    const closeLightbox = () => {
      if (!(lightbox instanceof HTMLElement) || lightbox.hidden) return;
      lightbox.hidden = true;
      if (lightboxImage instanceof HTMLImageElement) lightboxImage.removeAttribute('src');
      document.documentElement.classList.remove('seq-job-page-lightbox-open');
      if (lastTrigger instanceof HTMLElement && document.contains(lastTrigger)) lastTrigger.focus({ preventScroll: true });
    };

    page.addEventListener('click', event => {
      const trigger = event.target.closest('[data-seq-job-page-image]');
      if (!(trigger instanceof HTMLElement)) return;
      const imageUrl = trigger.dataset.fullImage;
      if (!imageUrl || !(lightbox instanceof HTMLElement) || !(lightboxImage instanceof HTMLImageElement)) return;

      lastTrigger = trigger;
      lightboxImage.src = imageUrl;
      lightbox.hidden = false;
      document.documentElement.classList.add('seq-job-page-lightbox-open');
      closeButton?.focus({ preventScroll: true });
    });

    closeButton?.addEventListener('click', closeLightbox);
    lightbox?.addEventListener('click', event => {
      if (event.target === lightbox) closeLightbox();
    });
    document.addEventListener('keydown', event => {
      if (event.key === 'Escape' && lightbox instanceof HTMLElement && !lightbox.hidden) closeLightbox();
    });
  }

  function init(scope = document) {
    scope.querySelectorAll('[data-seq-job-page]').forEach(initPage);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', event => init(event.target));
})();
